import React from "react";
import { IArticle } from "../interfaces/IArticle";
import { Link } from "@mui/material";
import DefaultSpacing from "../../cmp/page/DefaultSpacing";
import { useCmsData } from "../../hooks/useCmsData";
import Teaser from "../../cmp/page/article/Teaser";

interface ICmsArticleTeaser {
    id: string,
    language: ("de" | "en")
}

const CmsArticleTeaser : React.FC<ICmsArticleTeaser> = ({id, language}) => {
    const [data, loading, error] = useCmsData<Array<IArticle>>({docType: "article", additonalQueryString: `&& language == '${language}'`, docId: id, fields: `
        headline,
        category,
        image, 
        seoName,
        language
    `});

    const article = data?.[0];
    return <DefaultSpacing margin={{size: 'medium', applyTo: 'all'}}>
        {!loading && !error && article && <Link 
            href={`/${article?.language}/${article?.language === 'de' ? 'artikel' : 'article'}/${article?.seoName}`}
            sx={{"&:hover img": {
                    boxShadow: '0px 0px 20px #515151'
                }, textDecoration: 'none'}}
            >
            <Teaser article={article} />
        </Link>}
    </DefaultSpacing>
}

export default CmsArticleTeaser;